export default "__VITE_ASSET__18fBwEJ3jAY44oADWjyZjQ__"